import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import { useObserveScroll } from '../../helpers/use-observe-scroll';

interface IDispatchProps {
  loadMore: (page?: number) => void;
}

interface IOwnProps {
  minBodyHeight?: number;
  reset?: boolean;
  error?: boolean;
  children: React.ReactNode;
  libraryCards?: any[];
  hasMoreItems?: boolean;
  isFetching?: boolean;
  isError?: boolean;
}

interface IProps extends IOwnProps, IDispatchProps {}

const defaultProps: Partial<IProps> = {
  minBodyHeight: 0,
  hasMoreItems: false,
  libraryCards: [],
};

export const InfiniteScrollRQ: React.FC<IProps> = props => {
  const {
    minBodyHeight,
    loadMore,
    children,
    libraryCards,
    hasMoreItems,
    reset,
    isFetching,
    isError,
  } = {
    ...defaultProps,
    ...props,
  };
  const [isAtPageBottom, setIsAtPageBottom] = useState(false);

  const loadMoreCards = useCallback(() => {
    loadMore();
  }, [loadMore]);

  useObserveScroll(setIsAtPageBottom);

  useEffect(() => {
    setIsAtPageBottom(false);
  }, [libraryCards, reset]);

  useEffect(() => {
    const hasMinBodyHeight = document.body.offsetHeight > minBodyHeight;
    if (
      hasMinBodyHeight &&
      !isFetching &&
      hasMoreItems &&
      isAtPageBottom &&
      !isError
    ) {
      loadMoreCards();
    }
  }, [
    isAtPageBottom,
    isError,
    hasMoreItems,
    minBodyHeight,
    loadMoreCards,
    isFetching,
  ]);
  return (
    <>
      {React.Children.map(children, (child, index) => {
        return React.cloneElement(child as ReactElement, {
          index,
          libraryCards,
          hasMoreItems,
          error: isError,
          scrollLoading: isFetching,
        });
      })}
    </>
  );
};

export default InfiniteScrollRQ;
